<nav>
  <ul class="list-style-none p-2">
    @for(item of menuItems$(); track item) {
    <li>
      @if(item.children?.length) {
      <div class="btn btn-text w-full py-2 after:hidden 
          text-left text-lg lowercase highlighted
          rounded-xl transition-all cursor-default">
        {{item.text}}
      </div>
      <ul class="list-style-none pl-4 mt-1">
        @for(child of item.children; track child) {
        <li>
          <a [routerLink]="child.link"
             [fragment]="child.fragment"
             class="btn btn-text w-full py-1 px-3
              text-left text-base lowercase
              rounded-lg transition-all opacity-80 hover:opacity-100">
            {{child.text}}
          </a>
        </li>
        }
      </ul>
      } @else {
      <a [routerLink]="item.link"
         [fragment]="item.fragment"
         class="btn btn-text w-full py-2 
          text-left text-lg lowercase highlighted
          rounded-xl transition-all">
        {{item.text}}
      </a>
      }
    </li>
    }
  </ul>
</nav>

<mat-divider></mat-divider>

<div class="social-icons gap-4 p-4 px-6 flex items-center">
  <a [href]="contact.social.instagram.link"
     class="hover:!text-pink-500 transition-colors block w-max"
     aria-label="Instagram"
     target="_blank">
    <fa-icon [icon]="icons.faInstagram" class="text-2xl text-inherit"></fa-icon>
  </a>
</div>